<template>
  <div id="app">
    <router-view></router-view>
    <!--<kn-mainContainer></kn-mainContainer> -->
  </div>
</template>

<script>
import mainContainer from "./components/mainContainer.vue"

export default {
  components: {
    "kn-mainContainer": mainContainer
  },
  data() {
    return {

    }
  }
}
</script>

<style lang="scss">
.container {
  background: rgb(218, 231, 239);
  /* For browsers that do not support gradients */
  background: -webkit-linear-gradient(rgb(218, 231, 239), rgb(229, 241, 253), #edf6f8);
  /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradientrgb(rgb(218, 231, 239), rgb(229, 241, 253), #edf6f8);
  /* For Opera 11.1 to 12.0 */
  background: -moz-linear-gradient(rgb(218, 231, 239), rgb(229, 241, 253), #edf6f8);
  /* For Firefox 3.6 to 15 */
  background: linear-gradient(rgb(218, 231, 239), rgb(229, 241, 253), #edf6f8);
  border: 1px solid rgb(194, 192, 192);
  border-radius: 4px;
}

.main-content {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue